import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {CustomObjectEntityModel} from "../custom-object-entity.model";
import {OutletCustomObjectSearchModel} from "../outlet-custom-object-search.model";
import {CustomObjectSearchPageComponent} from "./custom-object-search-page.component";

@Component({
    selector: "wbo-outlet-custom-object-search-page",
    templateUrl: "custom-object-search-page.component.html",
    providers: [provideSearchModel(OutletCustomObjectSearchModel), provideEntityModel(CustomObjectEntityModel)]
})
export class OutletCustomObjectSearchPageComponent extends CustomObjectSearchPageComponent {
    override outletContext: boolean = true;

    constructor(searchModel: OutletCustomObjectSearchModel) {
        super(searchModel);
    }
}
